import React, { SyntheticEvent } from 'react'
import { Button } from 'antd'
//import './ActionBar.styles.css'



type propTypes = {
  onDelete?: (() => void) | ((e: SyntheticEvent) => void)  | (() => Promise<void>) | false
  onSave?: (() => void) | ((e: SyntheticEvent) => void) | (() => Promise<void>) | false
  onCancel?: (() => void) | ((e: SyntheticEvent) => void) | false
  disabledSave?: boolean
  show?: boolean
  warningMsg?: boolean
}

const ActionBar = (props: propTypes) => {
  const {
    onDelete = false,
    onCancel = false,
    onSave = false,
    disabledSave = false,
    show = true,
  
  } = props

  const anyActions = !onDelete && !onCancel && !onSave
  if (anyActions || !show) return <></>
  return (
    <div
      className='action-bar'
      >
      <div className='action-buttons-content'>
        <div className='actions-separator' />
        {onCancel && 
          <Button onClick={onCancel}>
            Cancel
          </Button>}
        {onSave && (
          <Button type='primary' disabled={disabledSave} htmlType="submit">
            Apply
          </Button>
        )}
      </div>
    </div>
  )
}

export default ActionBar
